import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedLobbySuccess } from "@src/ducks/slices/lobby.slice";
import { selectedUserCoins } from "@src/ducks/slices/user.slice";
import numeral from "numeral";
import React from "react";
import { Text } from "react-native";
import useStyles from "./styles.css";

const GoldCoins = ({ baseHeight }: any) => {
  const styles = useStyles();
  const balance  = useAppSelector(selectedUserCoins);
  const [currentGold, setCurrentGold] = React.useState(0);
  const lobbySuccess = useAppSelector(selectedLobbySuccess);

  const animationRef = React.useRef<number | null>(null);
  const startTimeRef = React.useRef<number | null>(null);
  const startValueRef = React.useRef(0);
  const targetValueRef = React.useRef(0);

  const clearAnimation = React.useCallback(() => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
      startTimeRef.current = null;
    }
  }, []);

  const animateTo = React.useCallback(
    (target: number, duration = 900) => {
      clearAnimation();

      const startValue = currentGold;
      startValueRef.current = startValue;
      targetValueRef.current = target;
      startTimeRef.current = null;

      const delta = target - startValue;

      if (!lobbySuccess) {
        setCurrentGold(target);
        return;
      }

      const animate = (timestamp: number) => {
        if (!startTimeRef.current) startTimeRef.current = timestamp;
        const elapsed = timestamp - startTimeRef.current;

        const progress = Math.min(elapsed / duration, 1);
        const newValue = startValue + delta * progress;

        setCurrentGold(newValue);

        if (progress < 1) {
          animationRef.current = requestAnimationFrame(animate);
        } else {
          clearAnimation();
          setCurrentGold(target);
        }
      };

      animationRef.current = requestAnimationFrame(animate);
    },
    [currentGold, lobbySuccess, clearAnimation]
  );

  React.useEffect(() => {
    animateTo(balance.GOLD + balance["GOLD BONUS"]);
    return clearAnimation;
  }, [balance]);

  return (
    <Text style={[styles.goldText, { fontSize: baseHeight * 0.17}]}
    >{numeral(currentGold).format("0,000.00")}</Text>
  );
};

export default GoldCoins;
